export default __webpack_public_path__ + "static/media/f_google.82468b9e.svg";